module.exports = function(app) {
    app.controller("pages.spending.transactionHistory", ["$scope", "session","services", "storage","coremetrics","$filter","spendingAccountsService","$q","spaUtil","accountTypes","$window","invisibleForm",'$timeout','dataManager',
        function( $scope, session,services, storage,coremetrics,$filter,spendingAccountsService,$q,spaUtil,accountTypes,$window,invisibleForm,$timeout,dataManager) {
            $scope.pagination = {
                itemsPerPage: '10'
            };
            $scope.pagination.page = 1;
            $scope.transactionSortOption = "-dateOfTransaction";
            $scope.transactionSortOptions = [
                {"label": "Default (Date)", "value": "-dateOfTransaction"},
                {"label": "Lowest to Highest Amount", "value": "amount"},
                {"label": "Highest to Lowest Amount", "value": "-amount"}
            ];
            $scope.sidebar.links=[];
            $scope.sidebar.transactionTypeFilters=[];


            $scope.spendingAccountTypes = accountTypes;
            $scope.rangeValue=0;
            $scope.sidebar.spendingAcctsTypeArray=[];
            var amountArray=[];
            var amount;
            var foundItem = false;
            dlTransactionsList = [];
            var txnCount = 0;
            $scope.currentMinimumValueOnChange = 0;
            $scope.currentMaximumValueOnChange = 0;
            var minimumValueSetForRange = 0,
                maximumValueSetForRange = 9999;
            var accountTypeCountObj = {};
            $scope.viewState="loading";







            //setsidebar links

            $scope.sidebar.links.push({
                heading: '<span data-teamsite="Transaction history"></span>',
                label: "Transaction history",
                state: "transactions",
                description: '<span data-teamsite="MSG_CNTR_LEFTNAV_DESC"></span>'
                //refineTemplate: 'spending.appTemplate.html/chmhom/pages/spending/transactionHistoryRefine'

            });




            var setUpPagination =function(){
                $scope.sidebar.filtersChanged = function() {
                    $scope.pagination.page = 1;
                };
                $scope.$watch('pagination.page', function(v) {
                    storage.set('transactionHistoryRefinePage', v);
                });
                $scope.$on('prevClick', function() {
                    var prevPage = $scope.pagination.page;
                    prevPage -= 1;
                    coremetrics.pageviewTag("MEMBER:TRANSACTION HISTORY " + prevPage, "MEMBER:SPENDING");
                    coremetrics.elementTag("PREV:TRANSACTION HISTORY", "MEMBER:SPENDING");
                });

                $scope.$on('nextClick', function() {
                    var nextPage = $scope.pagination.page;
                    nextPage += 1;
                    coremetrics.pageviewTag("MEMBER:TRANSACTION HISTORY " + nextPage, "MEMBER:SPENDING");
                });

                $scope.$on('goToPageClick', function() {
                    coremetrics.elementTag("SELECT PAGE NUMBER:TRANSACTION HISTORY", "MEMBER:SPENDING");
                });

            };


            var buildRefineContent =function(){
                var createDateRange = function(startDaysAgo, endDaysAgo) {
                    startDate = $filter('date')(new Date() - startDaysAgo*60*60*24*1000, 'yyyyMMdd')
                    endDate = endDaysAgo
                            ? $filter('date')(new Date() - endDaysAgo*60*60*24*1000, 'yyyyMMdd')
                            : $filter('date')(new Date(), 'yyyyMMdd');
                    return JSON.stringify({ startDate: startDate, endDate: endDate });
                };
                $scope.sidebar.transactionHistoryDateRange = createDateRange(365);
                $scope.sidebar.transactionHistoryDateRangeOptions = [
                    { label: "Last 12 Months", value: createDateRange(365) },
                    { label: "Last 6 Months", value: createDateRange(183) },
                    { label: "Last 90 Days", value: createDateRange(90) },
                    { label: "Last 60 Days", value: createDateRange(60) },
                    { label: "Last 30 Days", value: createDateRange(30) }

                ];
                //filter for date range
                $scope.$watch('sidebar.transactionHistoryDateRange', function(r) {
                    for (var i = 0, options = $scope.sidebar.transactionHistoryDateRangeOptions, value; i < options.length; i++) {
                        value = options[i].value;

                        if (value === r) {
                            if (i < 5) {
                                options.splice(5, 1);
                            }
                        }
                    }
                    $scope.fetchTransactions($scope.sidebar.transactionHistoryDateRange);
                });


                //filter on  transaction type
                $scope.transactionTypeFilter = function(transaction) {
                    /*var checkedTransactionsTypes = [];
                    var isValid=false;
                    var checkedTransactions  = $scope.sidebar.transactionTypeFilters.filter(function(transactionTypeObj){
                        var key;
                        for(key in transactionTypeObj){
                            if(transactionTypeObj[key].isChecked){
                                checkedTransactionsTypes.push(key);
                            }
                        }
                    });
                    var transactionType = transaction.typeOfTransaction || transaction.type;
                    if (checkedTransactionsTypes && checkedTransactionsTypes.includes(transactionType)) {
                        isValid= true;
                    }else{
                        isValid= false;
                    };

                    for (var r = 0; r < $scope.sidebar.spendingAcctsTypeArray.length; r++) {
                        if ($scope.sidebar.spendingAcctsTypeArray[r].hasOwnProperty(transaction.AccountType[0].accountTypeCode)) {
                            isValid= true;
                        }else{
                            isValid=false;
                        }
                    }
                    return false;*/

                    amount = transaction.amount;
                    //if nothing is selected, show everything
                    if ($scope.sidebar.spendingAcctsTypeArray.length === 0 && $scope.sidebar.transactionTypeFilters.length === 0) {

                        $scope.currentMinimumValueOnChange = +$scope.currentMinimumValueOnChange.toFixed(2);
                        $scope.currentMaximumValueOnChange = +$scope.currentMaximumValueOnChange.toFixed(2);

                        if($scope.currentMinimumValueOnChange <= amount && $scope.currentMaximumValueOnChange >= amount){
                            return true;
                        }
                    }else {
                        $scope.currentMinimumValueOnChange = +$scope.currentMinimumValueOnChange.toFixed(2);
                        $scope.currentMaximumValueOnChange = +$scope.currentMaximumValueOnChange.toFixed(2);


                        if ($scope.currentMinimumValueOnChange <= amount && $scope.currentMaximumValueOnChange >= amount &&
                            (($scope.sidebar.spendingAcctsTypeArray.length === 0 || filterOnSpendingAccountType(transaction))) &&
                            ($scope.sidebar.transactionTypeFilters.length === 0 || filterOnTransactionType(transaction))) {
                            return true;
                        }
                    }
                };




            };

            var filterOnTransactionType =function(transaction){
                var checkedTransactionsTypes = [];
                var isValid=false;
                $scope.sidebar.transactionTypeFilters.filter(function(transactionTypeObj){
                    var key;
                    for(key in transactionTypeObj){
                        if(transactionTypeObj[key].isChecked){
                            checkedTransactionsTypes.push(key);
                        }
                    }
                });
                var transactionType = transaction.typeOfTransaction || transaction.type;
                if (checkedTransactionsTypes && checkedTransactionsTypes.includes(transactionType)) {
                    isValid= true;
                }else{
                    isValid= false;
                };
                return isValid;
            };
            var filterOnSpendingAccountType =function(transaction){
                var checkedSpendingAccounts = [];
                var isValid=false;
                $scope.sidebar.spendingAcctsTypeArray.filter(function(spendingAccountTypeObj){
                    if(spendingAccountTypeObj.isChecked){
                        checkedSpendingAccounts.push(spendingAccountTypeObj.value);
                    }
                });
                var accountType = transaction.accountShortName;
                if (checkedSpendingAccounts && checkedSpendingAccounts.includes(accountType)) {
                    isValid= true;
                }else{
                    isValid= false;
                };
                return isValid;
            }

            var fetchSpendingAccountTypes=function(accountTypeCountObj){
                //filter on spending account type
                var spendingAcctTypeListObj = {};
                var spendingAcctType = null;
                var spendingAccountTypeObj;
                var spendingAcctsTypeArray = [];
                var accType = null;

                spendingAccountsService.getAllAmountsAndGlances().then(function (response) {

                    var hasSpendingAccount =    spendingAccountsService.hasSpendingAccount(response);
                    if(hasSpendingAccount){
                        dataManager.getCompleteAccountInfo(response).then(function(results){
                            var data = results.tempCompleteData;
                            if(data){
                                for ( var i = 0; i < data.length; ++i ) {
                                    spendingAcctType = spaUtil.getHmAccountTypes(data[i].accountType, "shortCode", data[i].groupCode,$scope.spendingAccountTypes);
                                    accType = data[i].accountType;

                                    if (!spendingAcctTypeListObj.hasOwnProperty(spendingAcctType)) {

                                        spendingAcctTypeListObj[spendingAcctType] = false;
                                        spendingAccountTypeObj = {};
                                        spendingAccountTypeObj.accType = accType;
                                        spendingAccountTypeObj.count = 0;
                                        spendingAccountTypeObj.value = spendingAcctType;
                                        spendingAccountTypeObj.label = spendingAcctType;
                                        spendingAccountTypeObj.isChecked = true;
                                        $scope.sidebar.spendingAcctsTypeArray.push(spendingAccountTypeObj);
                                    }

                                    console.log("spendingAccountTypeObj ",spendingAcctTypeListObj,"Does it contain? ",spendingAcctTypeListObj.hasOwnProperty(spendingAcctType));
                                }

                                for (var r = 0; r < $scope.sidebar.spendingAcctsTypeArray.length; r++) {
                                    if (accountTypeCountObj.hasOwnProperty($scope.sidebar.spendingAcctsTypeArray[r].accType)) {
                                        $scope.sidebar.spendingAcctsTypeArray[r].count = accountTypeCountObj[$scope.sidebar.spendingAcctsTypeArray[r].accType];
                                    }
                                }

                            }
                        });


                    }
                },function(){
                    $scope.errorMsg = "Spending Account is currently not available. Please try again later.";
                    $scope.viewState = 'error';

                });
            };
            $scope.fetchTransactions = function(dateRange) {
                var transactionPromises =[];
                dateRange = JSON.parse(dateRange || createDateRange(365));
                var startDate = dateRange.startDate.substr(4,2) + '/' + dateRange.startDate.substr(6,2) + '/' + dateRange.startDate.substr(0,4);
                    endDate =dateRange.endDate.substr(4,2) + '/' + dateRange.endDate.substr(6,2) + '/' + dateRange.endDate.substr(0,4);

                var getParams = {};
                getParams.clientName = "Mobile";
                getParams.pageSize = "99"; //fixed so service don't crash at 100.

                getParams.transactionStartDate = startDate;
                if(endDate){
                    getParams.transactionEndDate = endDate;
                }
                getParams.participantCode = session.data.memberInfo.umi+'0';
                var spendingAccountClient =spendingAccountsService.spendingAccountClients();
                if(spendingAccountClient && spendingAccountClient.length>0){
                    spendingAccountClient.forEach(function(client){
                        getParams.groupCode = client;
                        var transactionPromise = services.dpsext.getTransactionHistoryService().fetch(getParams);
                        transactionPromises.push(transactionPromise);
                    });
                };
                if(transactionPromises.length>0){
                    $q.all(transactionPromises).then(function(results){
                        triggerHasMoreRecordsCalls(results, getParams);
                    });
                }


            };


            var triggerHasMoreRecordsCalls = function(results, getParams) {
                var requests = [];
                var deferred;
                var baseResponse;
                var participantInfo;
                var paginationInfo;
                var transactionInfo;
                var transactionsList=[];



                results.forEach(function(response){
                    baseResponse = response.data.repGetTransactionReply.payload.repGetTransactionsData;
                    participantInfo = baseResponse.Participant;
                    paginationInfo = baseResponse.Pagination;
                    transactionInfo = baseResponse.Transactions;

                    transactionInfo.forEach(function(transaction){
                        transaction.groupCode = participantInfo.groupCode;
                        transactionsList.push(transaction);
                    });

                    if(paginationInfo.hasMoreRecords === "true") {
                        getParams.participantCode = participantInfo.participantCode;
                        getParams.groupCode = participantInfo.groupCode;
                        getParams.startAfterSequenceId = paginationInfo.lastSequenceId;
                        var transactionPromise = services.dpsext.getTransactionHistoryService().fetch(getParams);
                        requests.push(transactionPromise);
                    }
                });

                if(requests.length > 0){
                    $q.all(requests).then(function(results) {
                        triggerHasMoreRecordsCalls(results, getParams);
                    });
                }else{
                    buildTransactionHistory(transactionsList);
                }
            };

            var buildTransactionHistory = function (transactions) {
                    $scope.viewState="success";
                    $scope.transactions = transactions;
                    var amountCalc = function(amount, balance, type){
                        return balance;
                    };
                    var priorBalanceCalc = function(amount, balance, type){

                        var lAmt = parseFloat(amount);
                        var lBal = parseFloat(balance);
                        return (lBal - lAmt);
                    };

                    $scope.displayInfoArray = [];
                    var displayInfo = {};


                var transactionTypesWithCounts =[];
                var accountType = null;
                var accountTypeCountObj = {};
                var transactionType=null;


                transactions.forEach(function(transaction){
                    transactionType = transaction.type;
                    var transactionTypeExist =false;
                    transactionTypesWithCounts.forEach(function(transactionObj){

                            if(transactionObj.hasOwnProperty(transactionType)){
                                transactionTypeExist=true;
                                transactionObj[transactionType].count++;
                            }
                    });
                    if(!transactionTypeExist){
                        var obj = {};
                        obj[transactionType]={"count":1,"isChecked":true};
                        transactionTypesWithCounts.push(obj);
                    };
                    accountType = transaction.AccountType[0].accountTypeCode;

                    if (accountTypeCountObj.hasOwnProperty(accountType)) {
                        accountTypeCountObj[accountType] = accountTypeCountObj[accountType]+1;
                    } else{
                        accountTypeCountObj[accountType] = 1;
                    }
                    amountArray.push(Number(transaction.amount));

                    displayInfo = {
                        "dateOfTransaction": new Date(transaction.date),
                        "dateOfTransactionDisplay":transaction.date,
                        "accountPlan": spaUtil.getHmAccountTypes(transaction.AccountType[0].accountTypeCode, "shortCode", transaction.groupCode,$scope.spendingAccountTypes),
                        "typeOfTransaction": transaction.type,
                        "amount": parseFloat(transaction.amount),
                        "amountExpense": parseFloat(transaction.amount),
                        "accountShortName": spaUtil.getHmAccountTypes(transaction.AccountType[0].accountTypeCode, "shortCode", transaction.groupCode,$scope.spendingAccountTypes),
                        "description": transaction.description,
                        "priorHSABalance": priorBalanceCalc(transaction.amount, transaction.runningBalance, transaction.type),
                        "currentTransaction": parseFloat(transaction.amount),
                        "afterHSABalance": amountCalc(transaction.amount, transaction.runningBalance, transaction.type)

                    };

                    $scope.displayInfoArray.push(displayInfo);
                });
                amountArray.sort(function(amount1,amount2){

                    return amount1==amount2?0:(amount1>amount2?1:-1);
                });
                if(amountArray.length > 1){
                    minimumValueSetForRange =   parseFloat(amountArray[0]);
                    maximumValueSetForRange = parseFloat(amountArray[amountArray.length-1]);
                }else{
                    var amount = parseFloat(amountArray[0]);
                    if(amount > 0) {
                        minimumValueSetForRange =  parseFloat(0);
                        maximumValueSetForRange =  amount;
                    }
                    else {
                        minimumValueSetForRange =  amount;
                        maximumValueSetForRange =  parseFloat(0);
                    }
                };
                fetchSpendingAccountTypes(accountTypeCountObj);
                $scope.currentMinimumValueOnChange = minimumValueSetForRange;
                $scope.currentMaximumValueOnChange = maximumValueSetForRange;
                $scope.allTransactionArray = angular.copy($scope.displayInfoArray);
                $scope.sidebar.transactionTypeFilters = transactionTypesWithCounts;

            };



           $scope.downloadBtnForTransaction= function (downloadType) {
               var editTransactions = [];
               if($scope.transactions){
                   $scope.transactions.forEach(function(transaction){
                       if($scope.transactionTypeFilter(transaction)){
                           var editTransaction = transaction;
                           editTransaction.amount = parseFloat(transaction.amount);
                           editTransaction.dateOfTransaction=new Date(transaction.date);
                           editTransactions.push(editTransaction);
                       }
                   });

               }
               if($scope.transactionSortOption){
                   editTransactions =$filter('orderBy')(editTransactions, $scope.transactionSortOption);
               }



               for(var i=0; i<editTransactions.length; i++) {
                   editTransactions[i].AccountType[0].accountTypeCode = spaUtil.getHmAccountTypesNoNull(editTransactions[i].AccountType[0].accountTypeCode, "shortCode", editTransactions[i].groupCode,$scope.spendingAccountTypes);
               }

               var payload = {}, mLoadFunc = null, mErrorFunc = null;
               var payload = {
                   "payload" : {
                       "Transactions": editTransactions
                   }
               };

              var strPayload = JSON.stringify(payload, spaUtil.jsonScrubber);

               var downloadAction = '';

               switch(downloadType){
                   case 'excel':
                       downloadAction  = '/rbsmbl/x-services/spendingAccount/transactions';
                       break;
                   case 'pdf':
                       downloadAction  = '/rbsmbl/x-services/spendingAccount/v1/pdf/transactions';
                       break;
                   default:
                       downloadAction='';
                       break;

               }

               var formConfig = {
                   name: 'transactionsDLForm',
                   id: 'transactionsDLForm',
                   formTarget: 'InvisibleSsoSvcs',
                   method: 'POST',
                   action: downloadAction,
                   target: '',
                   inputs: {
                       name:'payload',
                       payload:strPayload
                   }
               };
               invisibleForm.submit(formConfig);
            };

            setUpPagination();
            $timeout(function(){
                buildRefineContent();
            },500);


        }]);

};